import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOuterOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderOuterOutlined";
import AntdIcon from '../components/AntdIcon';
var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BorderOuterOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BorderOuterOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BorderOuterOutlined';
}
export default RefIcon;